import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import DocumentMeta from 'react-document-meta';
import Client from '../../utils/Client';
import SignupBusiness from '../blocks/SignupBusiness';
import { LOCATION, DOMAIN } from '../../utils/Constants';
import ModalLarge from '../blocks/ModalLarge';

function Priority({...props}){
  return (
    <div>
      <h4 className="no-margin">Why get a PRIORITY Listing?</h4>
      <p><span className="bold promo-heading">It's free!</span><br/> Because our site is newly launched, for a limited time we are giving all those who sign up now a Priority listing for free as a thank you for your support.</p>

      <p><span className="bold promo-heading">You'll be seen first!</span><br/> Your business listing will display at the very top of the list, with a larger title, logo and social media links if you have them.</p>

      <p><span className="bold promo-heading">Customised content!</span><br/> On the details page of your business, you will be able to display more customised content than on a normal listing detail page. Your logo and a detailed description of your business will be displayed, as well as your social media (Facebook, Twitter) links if you have them, and any photos you would like to add. Visitors to your page will also be able to contact you directly by filling out a simple contact form that we provide on your page. Your email address will be hidden from the page, so no need to worry about spam.</p>

      <p><span className="bold promo-heading">Promote special offers!</span><br/> COMING SOON: On the details page of your business, you will be able to display special offers you want to promote to your customers.</p>

      <p><span className="bold promo-heading">Discount on a new website for your business!</span><br/> In the near future, we will be offering professional web design and hosting services. We will offer a discount to anyone who needs either a website overhaul or a new website who has signed up early with us for a Priority listing. (details coming soon)</p>
      <Link to='/' onClick={props.toggleModal} className="button modal-button">Get Started!</Link>
    </div>
    
  )
}

class GetFound extends Component {
  state = {
    modalOpen: false
  }
  componentDidMount(){
    Client.triggerTracking();
    window.scrollTo(500, 0);
  }
  toggleModal = (e) => {
    e.preventDefault();
    window.scrollTo(500, 0);
    this.setState({
      modalOpen: !this.state.modalOpen
    })
  }
  render(){
    const meta = {
      title: `― Get Found in ${LOCATION}, Essex, UK ―`,
      description: `Get your business, service in ${LOCATION} or event listed on ${LOCATION} Online`,
      canonical: `http://www.${DOMAIN}/getfound`
      
    };
    let modalClass = '';
    if(this.state.modalOpen){
      modalClass = 'show';
    }
    return(
      <div className="page-content-wrapper">
        <DocumentMeta {...meta} />
        <ModalLarge
          title={'Priority Listing'}
          modalClass={modalClass}
          toggleModal={this.toggleModal}
        >
          <Priority 
            toggleModal={this.toggleModal}
          />
        </ModalLarge>
        <div className="row">
            <div className="large-12 columns">
              <h2 className="form-heading">Get found in {LOCATION}!</h2>
              <p>Getting a <Link onClick={this.toggleModal} to="/"><span className="bold">PRIORITY listing</span></Link> for your {LOCATION} business, service or event on <span className="bold">{LOCATION} Online</span> is easy, and for a limited time, it's also <span className="bold">free</span>! </p>
              <p className="modal-link"><Link onClick={this.toggleModal} to="/"><i className="fa fa-question-circle" aria-hidden="true"></i>What is a PRIORITY listing?</Link></p>
              <p><span className="bold">Get in there!</span> Fill out the form below, it won't take long! <span className="text-small">(* = required)</span></p>

              <SignupBusiness/>
          </div>
        </div>
      </div>
    );
  }
}
export default GetFound;


// WEBPACK FOOTER //
// ./src/components/pages/GetFound.js